module.exports = __webpack_public_path__ + "static/img/20011 (3).2c53517.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20011 (3).webp
// module id = toZG
// module chunks = 14